import { CheckCircle2, Award } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { IMAGES } from "../config";

const POINTS = [
    "Esperienza diretta nel mondo della tecnologia e della trasformazione digitale",
    "Metodo orientato ai risultati: l'IA come leva concreta di performance",
    "Percorsi su misura per Creator, professionisti e aziende di ogni dimensione",
];

export const About = () => (
    <section id="chi-sono" data-testid="about-section" className="relative py-20 sm:py-28">
        <div className="mx-auto max-w-6xl px-5 sm:px-8 grid gap-12 lg:grid-cols-2 lg:items-center">
            <Reveal className="relative order-2 lg:order-1">
                <div className="relative rounded-[2rem] overflow-hidden shadow-2xl shadow-sky-900/15">
                    <img
                        src={IMAGES.portrait}
                        alt="Maria Fasanella al lavoro"
                        className="w-full aspect-[4/3] object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-tr from-[#0096C7]/25 to-transparent" />
                </div>
                <div className="absolute -bottom-6 left-6 right-6 sm:right-auto glass rounded-2xl px-5 py-4 shadow-xl shadow-sky-900/10 flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#03045E] text-[#48CAE4]">
                        <Award className="h-5 w-5" />
                    </span>
                    <div>
                        <p className="font-display font-bold text-[#03045E]">Creator Plus</p>
                        <p className="text-xs text-slate-500">Tecnologia · IA · Crescita</p>
                    </div>
                </div>
            </Reveal>

            <div className="order-1 lg:order-2">
                <Reveal>
                    <SectionLabel>Chi sono</SectionLabel>
                    <h2
                        data-testid="about-heading"
                        className="mt-5 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#03045E] leading-tight"
                    >
                        Ciao, sono Maria Fasanella.
                        <span className="block text-gradient-azure">
                            Porto l'IA nella tua performance.
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Sono una Creator Plus: vivo nel mondo della tecnologia e
                        dell'Intelligenza Artificiale Performance, e la mia missione è
                        rendere questi strumenti accessibili, pratici e redditizi.
                        Lavoro al fianco di Creator e aziende per costruire processi
                        più intelligenti, contenuti più efficaci e nuove opportunità
                        di business.
                    </p>
                    <p className="mt-4 text-base text-slate-600 leading-relaxed">
                        Credo in un approccio semplice: niente teoria fine a sé stessa,
                        solo strategie che puoi applicare da subito e misurare nel tempo.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <ul className="mt-7 space-y-3.5" data-testid="about-points">
                        {POINTS.map((p) => (
                            <li key={p} className="flex items-start gap-3">
                                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#0096C7]" />
                                <span className="text-sm sm:text-base text-slate-700">{p}</span>
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </div>
    </section>
);
